import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=126acd91"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports